import { Actions } from '../actions/ViewActions';

const viewReducer = (state: any, action: any) => {
  switch (action.type) {
    case Actions.CHECK_UNGROUP:
      return {
        ...state,
      };
    default:
      return null;
  }
};

export default viewReducer;
